import apiClient from './apiClient';

export interface WsTokenResponse {
  ws_token: string;
}

const wsTokenApi = {
  // Exchange the session token (Authorization header, added by apiClient) for
  // the short-lived single-purpose token the ActionCable handshake accepts.
  // The real session JWT must never appear in the /ws URL query string.
  create: () => apiClient.post<WsTokenResponse>('/direct/usersvc/auth/ws-token'),
};

export default wsTokenApi;
